import React from 'react'

export const closeSvg = <svg className="closeSvg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="-3.083 -2.083 30 30" enableBackground="new -3.083 -2.083 30 30" xmlSpace="preserve">
<g id="Group_2473" transform="translate(-732 8712)">
	<path id="Path_531" d="M749.661-8707.083l-5.744,5.744l-5.744-5.744l-2.256,2.257l5.744,5.743l-5.744,5.743
		l2.256,2.257l5.744-5.743l5.744,5.743l2.256-2.257l-5.744-5.743l5.744-5.743L749.661-8707.083z"/>
</g>
</svg>

export const send = <svg version="1.1" id="Capa_1" className="sendSVG" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 17.3 14" enableBackground="new 0 0 17.3 14;" xmlSpace="preserve">
<g id="Group_3967" transform="translate(-10472 -10547) rotate(-30)">
<g id="Group_984" transform="translate(0)">
   <path id="Path_570" className="st0" d="M3794.5,14371.8l0,5.3l11.4,1.5l-11.4,1.5l0,5.3l16-6.9L3794.5,14371.8z"/>
</g>
</g>
</svg>

export const tacheCirculo = <svg xmlns="http://www.w3.org/2000/svg"  viewBox="4426 4347 16 16">
<defs>
  <clipPath id="clip-path">
    <path id="Path_1711" data-name="Path 1711" className="cls-1" d="M0-20H16V-4H0Z" transform="translate(0 20)"/>
  </clipPath>
</defs>
<g id="Group_5421" data-name="Group 5421" className="cls-2" transform="translate(4426 4347)">
  <g id="Group_3172" data-name="Group 3172" className="cls-3">
    <g id="Group_3171" data-name="Group 3171" transform="translate(0 0)">
      <path id="Path_1710" data-name="Path 1710" d="M-3-2.718-4.128-1.59-7-4.462-9.872-1.59-11-2.718-8.128-5.59-11-8.462-9.872-9.59-7-6.718-4.128-9.59-3-8.462-5.872-5.59ZM-7-13.59a7.993,7.993,0,0,0-8,8,7.993,7.993,0,0,0,8,8,7.993,7.993,0,0,0,8-8,7.993,7.993,0,0,0-8-8" transform="translate(15 13.59)"/>
    </g>
  </g>
</g>
</svg>

export const arrowBack = <svg version="1.1" className="arrowBack" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
width="100%" height="100%" viewBox="0 0 640 480" enableBackground="new 0 0 640 480;" xmlSpace="preserve">
<g id="Group_958" transform="translate(80 82) rotate(-90)">
<g id="Group_957">
   <g id="Group_956">
       <g id="Group_955">
           <g id="Group_954">
               <path id="Path_560" className="st0" d="M-271.5,332.7l114.4-114.2L-43,332.7l35.3-35.1l-149.5-149.5l-149.5,149.5L-271.5,332.7z"/>
           </g>
       </g>
   </g>
</g>
</g>
</svg>

export const btnClear = <svg version="1.1" className="btnClearSVG" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 30 30" enableBackground="new 0 0 30 30;" xmlSpace="preserve">
<path className="st0" d="M15,1.2C7.5,1.2,1.3,7.3,1.3,14.9c0,7.6,6.2,13.7,13.7,13.7c7.6,0,13.7-6.2,13.7-13.7C28.8,7.3,22.6,1.2,15,1.2
   z M23,20.6l-2.3,2.3L15,17.2l-5.7,5.7L7,20.6l5.7-5.7L7,9.2l2.3-2.3l5.7,5.7l5.7-5.7L23,9.2l-5.7,5.7L23,20.6z"/>
</svg>

export const starFav = <svg version="1.1" className="starFav" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 20 20" enableBackground="new 0 0 20 20;" xmlSpace="preserve">
<path id="Path_2060" className="st1" d="M10,13.2l3.7,2.8l-1.4-4.6L16,8.7h-4.6L10,4L8.6,8.7H4l3.7,2.7L6.3,16L10,13.2z"/>
</svg>

export const deleteNumber = <svg version="1.1" className="deleteNumberSVG" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 21.3 16" enableBackground="new 0 0 21.3 16;" xmlSpace="preserve">
<path id="Path_1974" className="st0" d="M19.6,0H6.2C5.6,0,5.1,0.3,4.8,0.8L0,8l4.8,7.2C5.1,15.7,5.6,16,6.2,16h13.3
	c1,0,1.8-0.8,1.8-1.8V1.8C21.3,0.8,20.5,0,19.6,0z M16.9,11.2l-1.2,1.2l-3.2-3.2l-3.2,3.2L8,11.2L11.2,8L8,4.8l1.2-1.2l3.2,3.2
	l3.2-3.2l1.2,1.2L13.7,8L16.9,11.2z"/>
</svg>

export const triangle = <svg version="1.1" className="triangleSVG" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 8 7" enableBackground="new 0 0 8 7;" xmlSpace="preserve">
<path id="Path_1131" className="st0" d="M8,0H0l4,7L8,0z"/>
</svg>

export const clockIcon = <svg className="clockSvg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
<g>
	<g>
		<path className="st0" d="M20,1.1C9.6,1.1,1.1,9.6,1.1,20S9.6,38.9,20,38.9c10.5,0,18.9-8.5,18.9-18.9S30.4,1.1,20,1.1z M20,35.1
			c-8.4,0-15.1-6.8-15.1-15.1S11.7,4.9,20,4.9S35.1,11.7,35.1,20S28.4,35.1,20,35.1z"/>
		<path className="st0" d="M21,10.6h-2.8v11.3l9.9,6l1.4-2.3l-8.5-5V10.6z"/>
	</g>
</g>
</svg>

export const agentSVG = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 640 480" enableBackground="new 0 0 640 480" xmlSpace="preserve">
<g id="Group_951" transform="translate(2124 1771)">
	<g id="Group_949" transform="translate(3 0)">
		<path id="Path_556" className="st0" d="M-1829.9-1766.5c55.1,0,99.8,44.7,99.8,99.8c0,55.1-44.7,99.8-99.8,99.8s-99.8-44.7-99.8-99.8
			C-1929.8-1721.8-1885-1766.5-1829.9-1766.5"/>
	</g>
	<g id="Group_950" transform="translate(0 7.9)">
		<path id="Path_557" className="st0" d="M-1826.9-1301.9c-80.3,0-155.3-40.2-199.7-107.2c1-66.3,133.1-102.5,199.7-102.5
			s198.7,36.2,199.7,102.5C-1671.7-1342.1-1746.6-1301.9-1826.9-1301.9"/>
	</g>
</g>
</svg>

export const arrowNDlogSVG = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
width="12px" height="7.411px" viewBox="0 0 12 7.411" enableBackground="new 0 0 12 7.411" xmlSpace="preserve">
<path id="Path_989" fill="#D5D5D5" d="M6,7.411l6-6L10.59,0L6,4.58L1.411,0L0,1.411L6,7.411z"/>
</svg>



// WEBPACK FOOTER //
// ./src/Images/GenericSVG.js